<template>
  <el-col class="RightPart">
    <el-card shadow="hover" :body-style="{padding: '0px',height: '100px'}" style="margin-top: 8px">
      <div class="C-InfoCard">
        <div class="Content" style="margin-left: 10px">
          <div class="Profile">
            <div class="p4" style="color: #ff3399">
              * 特别提醒：请勿在联系对方时告诉对方信息来源！
            </div>
          </div>
          <div class="Profiles">
            <router-link to="/help" class="navbar-nav">
              <el-button plain  size="small">
                <svg-icon icon-class="Identify" style="fill:#f39"></svg-icon>
                <span style="font-size: 14px">鉴别指南</span>
              </el-button>
            </router-link>
            <router-link to="/help" class="navbar-nav">
              <el-button plain size="small">
                <svg-icon icon-class="rule" style="fill:#f39"></svg-icon>
                <span style="font-size: 14px">信息规则</span>
              </el-button>
            </router-link>
          </div>
        </div>
      </div>
    </el-card>
    <div class="G-title">
      <svg-icon icon-class="address" style=""></svg-icon>
      本地其他推荐</div>
    <router-link :to="{path:'/show',query:{id:item.id}}" v-for="item of r_data" :key="item.id">
      <el-card shadow="hover" :body-style="{padding: '0px',height: '160px'}" style="margin: .1rem !important">
        <div class="C-InfoCard">
          <div class="Content">
            <div class="Title">{{item.title}}</div>
            <div>
              <div class="State">
                <div>
                  <svg-icon icon-class="time" style="fill:#999"></svg-icon>
                  <span>{{item.create_time}}</span>
                </div>
                &nbsp;&nbsp;
                <div>
                  <svg-icon icon-class="browse" style="fill:#999"></svg-icon>
                  <span>{{item.browse}}</span>
                </div>
              </div>
              <div class="Desc">{{item.process}}</div>
            </div>
            <div class="Location">
              <div class="Left">
                <svg-icon icon-class="address" style="fill:#f39"></svg-icon>
                <span>{{item.city}}</span>
              </div>
              <div class="Tags">
                <span class="ant-tag" v-if="item.type === 1">商家</span>
                <span class="ant-tag" v-if="item.type === 2">商家</span>
              </div>
            </div>
          </div>
          <img  class="Cover" :src="item.img"
                onerror="this.remove()">
        </div>
      </el-card>
    </router-link>
  </el-col>
</template>

<script>
export default {
  name: 'recommend',
  props: {
    r_data: {
      type: Array
    }
  },
  methods: {
    get_show (id) {
      this.$emit('get_show', id)
    }
  }
}
</script>

<style scoped>
  .C-InfoCard {
    position: relative;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .Cover {
    height: 132px;
    margin: 13px 16px 16px 0;
    border-radius: 4px;
  }

  .Title {
    color: #333;
    font-size: 16px;
    padding: 16px 8px 8px 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .State {
    padding: 0px 8px 8px 16px;
    color: #999 !important;
    padding-left: 1rem !important;
    padding-bottom: .5rem !important;
    padding-right: .5rem !important;
    display: flex !important;
    font-size: 14px;
  }

  .svg-icon {
    width: 1.1em;
    height: 1.1em;
    vertical-align: -0.15em;
    fill: currentColor;
  }
  .Content {
    overflow: hidden;
    width: 100%;
    text-align: left;
  }
  .Desc {
    height: 40px;
    overflow: hidden;
    padding-left: 1rem!important;
    padding-right: .5rem!important;
    font-size: 14px;
  }
  .Location{
    padding: 8px 8px 16px 16px;
    font-size: 14px;
    align-items: center!important;
    justify-content: space-between!important;
    display: flex!important;
  }
  .Left {
    color: #f39;
  }
  .G-title{
    border-bottom: 1px solid #f2f2f2!important;
    font-size: 16px;
    color: #333!important;
    padding: 1rem!important;
    margin-bottom: .25rem!important;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/RightPart.vue